import { api } from '../../lib/api.ts';
import type { Body } from '../../lib/body.ts';

export type DecisionStatus = 'NOT_STARTED' | 'ONGOING' | 'ON_HOLD' | 'IMPLEMENTED';

export interface ThanfeezuDecision {
  yaumiyyaId: string;
  agendaItemId: string;
  proposalIndex: number;
  meetingId: string;
  meetingTitle: string;
  meetingDate: string;
  ninmunNumber: string;
  ninmunNumberRaw: number | null;
  ninmunPassedAt: string;
  itemNumber: number;
  proposalNumber: number;
  hasMultipleProposals: boolean;
  proposalText?: string;
  decisionText?: string;
  status: DecisionStatus;
  note: string | null;
  targetDate: string | null;
  completedDate: string | null;
  updatedAt: string | null;
}

export interface ThanfeezuStats {
  total: number;
  counts: Record<DecisionStatus, number>;
  pctImplemented: number;
  avgDaysToImplement: number | null;
  overdue: number;
}

export interface ThanfeezuResponse {
  stats: ThanfeezuStats;
  decisions: ThanfeezuDecision[];
}

export interface DecisionPatch {
  status?: DecisionStatus;
  note?: string | null;
  targetDate?: string | null;   // YYYY-MM-DD or null
  completedDate?: string | null;
}

export const thanfeezuApi = {
  list: (body: Body, termId?: string) =>
    api.get<ThanfeezuResponse>('/thanfeezu', { params: { body, ...(termId ? { termId } : {}) } }).then((r) => r.data),
  update: (d: Pick<ThanfeezuDecision, 'yaumiyyaId' | 'agendaItemId' | 'proposalIndex'>, patch: DecisionPatch) =>
    api
      .patch<ThanfeezuDecision>(
        `/thanfeezu/${d.yaumiyyaId}/${d.agendaItemId}/${d.proposalIndex}`,
        patch,
      )
      .then((r) => r.data),
};
